<template>
  <a-modal
    @ok="handleSave"
    @cancle="handleCancle"
    v-model:visible="addModal"
    :title="title"
    centered
    width="450px"
    wrapClassName="css-vslrb1"
  >
    <div>
      <div class="addModal">
        <span>航线名称</span>
        <a-input
          placeholder="请输入航线名称"
          v-model:value="waylineForm.name"
          class="mt5 css-vslrb1"
        ></a-input>
        <div class="form-tips" v-show="errorForm.nameNone">
          航线名称不能为空
        </div>
        <div class="form-tips" v-show="errorForm.nameOr">
          航线名称已存在，请修改后重试
        </div>
      </div>
      <!--
      <div class="addModal">
        <span>关联机场</span><br />
        <a-select
          v-model:value="assAirport"
          placeholder="请选择关联机场"
          class="sel"
          clearable
          dropdownClassName="dark-select-dropdown"
        >
          <a-select-option
            v-for="device in dockSnList"
            :key="device.device_sn"
            :value="device.device_sn"
            >{{ device.device_name }}</a-select-option
          >
        </a-select>
      </div> -->

      <div class="addModal">
        <span>关联部门</span><br />
        <div class="dept-selector">
          <a-input
            v-model:value="waylineForm.dept_names"
            readonly
            placeholder="请选择关联部门"
            class="flex1 css-vslrb1"
          />
          <PlusCircleTwoTone
            class="fz20 ml10 cur-p"
            @click="showDeptPanel = !showDeptPanel"
          />
        </div>
        <div v-if="showDeptPanel" class="dept-panel">
          <div class="dept-panel-header">
            <span>选择部门</span>
            <CloseOutlined @click="showDeptPanel = false" />
          </div>
          <div class="dept-tree-container">
            <a-tree
              v-if="deptTreeData.length"
              :tree-data="deptTreeData"
              :checked-keys="selectedDeptKeys"
              checkable
              class="css-vslrb1"
              :check-strictly="true"
              @check="onDeptCheck"
              :expanded-keys="expandedDeptKeys"
              @expand="(keys) => (expandedDeptKeys = keys)"
            />
            <a-empty
              v-else
              description="暂无部门数据"
              :image-style="{ height: '60px' }"
            />
          </div>
        </div>
      </div>

      <div class="addModal">
        <span>巡检区域</span><br />
        <!-- <a-select v-model:value="waylineForm.inspection_area_id" placeholder="请选择巡检区域" class="sel">
          <a-select-option v-for="item in flightData" :key="item.id" :value="item.id">{{ item.areaName }}</a-select-option>
        </a-select> -->
        <a-tree-select
            v-model:value="waylineForm.inspection_area_id"  class="sel css-1dowtov"
            :tree-data="flightAreaTreeData"
            placeholder="请选择巡检区域"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            allow-clear
            dropdownClassName="css-1dowtov gobal-route-setting-select-dropdown"
          />
      </div>

      <div class="addModal">
        <span>航线属性</span><br />
        <a-select v-model:value="waylineForm.wayline_property" class="sel css-1dowtov"
         dropdownClassName="css-1dowtov gobal-route-setting-select-dropdown">
          <a-select-option
            v-for="item in waylineAttribute"
            :key="item.dictValue"
            :value="item.dictValue"
            >{{ item.dictLabel }}</a-select-option
          >
        </a-select>
      </div>

      <div v-if="waylineForm.wayline_property === '1'" class="addModal">
        <span>适用人员</span>
        <a-button type="text" class="ml-63 c189 css-vslrb1" @click="createUserPanel"
          >添加人员</a-button
        >
        <a-input
          v-model:value="waylineForm.user_names"
          readonly
          class="css-vslrb1"
          placeholder="请选择人员"
        ></a-input>
      </div>

      <div class="addModal">
        <span>选择飞机飞行器与负载</span><br />
        <a-select
          v-model:value="choseValue"
          class="chose css-1dowtov"
          @change="handleDeviceChange"
         dropdownClassName="css-1dowtov gobal-route-setting-select-dropdown"
        >
          <a-select-option
            v-for="item in DEVICE_SERVER_LIST"
            :key="item.value"
            :disabled="
              waylineForm.template_types.includes('3') &&
              item.value === DRONE_TYPE.M30
            "
            :value="item.value"
          >
            {{ item.label }}</a-select-option
          >
        </a-select>
        <a-select
          v-model:value="videoValue"
          class="chose ml5 css-1dowtov"
          @change="handleDeviceCameraChange"
          dropdownClassName="css-1dowtov gobal-route-setting-select-dropdown"

        >
          <a-select-option
            v-for="item in DEVICE_CAMERA_LIST[choseValue]"
            :disabled="
              waylineForm.template_types.includes('3') &&
              choseValue === DRONE_TYPE.M30
            "
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}</a-select-option
          >
        </a-select>
      </div>

      <div v-if="cameraPayload.length > 0" class="addModal">
        <span>选择负载</span><br />
        <a-button
          v-for="item in cameraPayload"
          :key="item.id"
          :value="item.id"
          class="ml5 css-vslrb1"
          >{{ item.dict_label }}</a-button
        >
        <div v-if="title !== '新增航线'" class="form-tips">
          由于机型/负载之间的能力差异，航线文件中在转换后的机型/负载上无法执行的航点动作将会移除，可执行的航点动作将会保留且部分参数会被重置。可将航线复制备份后，再进行转换。
        </div>
      </div>

      <div class="addModal" v-if="!waylineForm.id">
        <span>航线类型</span><br />
        <div class="mt5">
          <a-button
            @click="handleChangeType(item)"
            v-for="item in waylineComType"
            :key="item.id"
            :value="item.id"
            :data-id="item.dictValue"
            :class="{
              'ant-btn-true': waylineForm.template_types.includes(item.dictValue),
            }"
            class="ml5 css-vslrb1 wayline-type-btn"

          >
            <template #icon>
              <i
                class="iconfont icon-waypoint"
                :data-id="item.dictValue"
                v-show="item.dictValue === '0'"
              ></i>
              <i
                class="iconfont icon-mapping2d"
                :data-id="item.dictValue"
                v-show="item.dictValue === '1'"
              ></i>
              <i
                class="iconfont icon-mappingStrip"
                :data-id="item.dictValue"
                v-show="item.dictValue === '3'"
              ></i>
            </template>
            {{ item.dictLabel }}
          </a-button>
        </div>
      </div>
    </div>

    <!-- 外部并排的添加人员面板 -->
    <div v-if="showUserPanel" :style="userPanelStyle">
      <div class="user-top">
        <div class="user-text">添加人员</div>
        <div class="user-close">
          <close-outlined @click="handleCloseUserPanel"></close-outlined>
        </div>
      </div>

      <a-checkbox-group
        v-model:value="selectedUserIds"
        style="width: 100%"
        class="css-vslrb1"
        @change="handleUserPanelChange"
      >
        <a-row>
          <a-col :span="24" v-for="user in userList" :key="user.user_id">
            <a-checkbox :value="user.user_id">{{ user.username }}</a-checkbox>
          </a-col>
        </a-row>
      </a-checkbox-group>
    </div>
    <a-modal
      :footer="false"
      :closable="false"
      v-model:visible="updateTipModal"
      width="420px"
      centered
      wrapClassName="route-update-modal del-modal css-vslrb1"
    >
      <div class="route-modal-title">更新</div>
      <div class="route-modal-form-data">
        <div class="form-key">
          更换飞行器或负载型号将影响航线作业参数，请谨慎操作!
        </div>
      </div>

      <div class="route-modal-footer">
        <a-button @click="handleCloseUpdate">取消</a-button>
        <a-button type="danger" @click="handleChangeUpdate">确认</a-button>
      </div>
    </a-modal>
  </a-modal>
</template>
<script setup lang="ts">
import {
  ref,
  defineEmits,
  withDefaults,
  defineExpose,
  defineProps,
  onMounted,
  computed,
} from 'vue'
import { lineSaveForm } from '/@/api/wayline'
import {
  Device,
  DEVICE_CAMERA_LIST,
  DEVICE_SERVER_LIST,
  DRONE_TYPE,
} from '/@/types/device'
import { ELocalStorageKey } from '/@/types'
import { getAllUsersInfo, getDevice } from '/@/api/manage'
import { IPage } from '/@/api/http/type'
import { getDictList } from '/@/api/algCode'
import {
  getCheckInspectionAreasList,
  getDeptList,
} from '/@/api/insp/insp-dept'

// 计算面板定位样式
const userPanelStyle = computed(() => ({
  position: 'fixed',
  top: '41%',
  left: 'calc(50% + 225px + 4px)', // 450px/2+24px间距
  transform: 'translateY(-50%)',
  width: '320px',
  background: '#fff',
  padding: '8px 12px',
  boxShadow: '-2px 0 4px rgba(0,0,0,0.06)',
  zIndex: 2000,
  borderRadius: '4px',
  minHeight: '300px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  justifyContent: 'flex-start',
}))

const props = withDefaults(
  defineProps<{
    title?: string;
  }>(),
  {
    title: '新建航线',
  },
)
interface SavePayload {
  form: lineSaveForm;
  assAirport: string;
  choseValue: number;
  videoValue: number;
  errorForm: {
    nameNone: boolean;
    nameOr: boolean;
  };
}
const emits = defineEmits<{
  save: [SavePayload];
}>()

const addModal = ref(false)
const workspaceId = localStorage.getItem(ELocalStorageKey.WorkspaceId)!
const waylineForm = ref<lineSaveForm>({
  name: '',
  drone_model_key: '',
  payload_model_keys: [],
  template_types: [],
  wayline_property: '',
  user_names: '',
  user_id_list: [],
  dept_ids: '',
  dept_names: '',
  inspection_area_id: null,
})
const errorForm = ref({
  nameNone: false,
  nameOr: false,
})
const assAirport = ref(null)
const dockSnList = ref<Device[]>([])
const cameraPayload = ref<any[]>([])
const waylineComType = ref<any[]>([])
const attributes = ref('')
const updateTipModal = ref(false)
const updateType = ref('')
const updateId = ref(null)
const choseValue = ref(DRONE_TYPE.M30)

const videoValue = ref(DEVICE_CAMERA_LIST[choseValue.value][0].value)

const waylineAttribute = ref<any[]>([])
const showUserPanel = ref(false)
const userList = ref<any[]>([])
const selectedUserIds = ref<string[]>([])
const body: IPage = {
  page: 1,
  total: 0,
  page_size: 100,
}
function createUserPanel () {
  if (showUserPanel.value) {
    handleCloseUserPanel()
    return
  }
  showUserPanel.value = true
  if (userList.value && userList.value.length > 0) {
    return
  }
  getAllUsersInfo(workspaceId, body).then((res) => {
    if (res && res.code === 0) {
      userList.value = res.data.list
    }
  })
}
function handleCloseUserPanel () {
  showUserPanel.value = false
}
function handleUserPanelChange (val: string[]) {
  const names = userList.value.filter((u) => val.includes(u.user_id))
  waylineForm.value.user_names = names.map((u) => u.username).join(', ')
  waylineForm.value.user_id_list = names.map((u) => u.user_id)
}

async function waylineAttList () {
  const res = await getDictList('route_attribute')
  if (res && res.code === 0) {
    waylineAttribute.value = res.data || []

    if (waylineAttribute.value.length > 0) {
      waylineForm.value.wayline_property = waylineAttribute.value[0].dictValue
    }
  }
}

async function getDockSN () {
  try {
    const param = {
      workspace_id: workspaceId,
      domains: [3],
    }
    const res = await getDevice(param)
    if (res && res.code === 0) {
      dockSnList.value = res.data
    }
  } catch (e) {
    console.log('获取设备列表时发生异常:', e)
  }
}
const oldDeviceValue = ref(null)
const oldDeviceCameraValue = ref(null)
function handleDeviceChange (selectedId) {
  if (waylineForm.value.id) {
    updateType.value = 'device'
    updateTipModal.value = true
    updateId.value = selectedId
    return
  }
  const row = DEVICE_SERVER_LIST.find((el) => el.value === selectedId)
  videoValue.value = DEVICE_CAMERA_LIST[selectedId][0].value
}

function handleChangeUpdate () {
  if (updateType.value === 'device') {
    oldDeviceCameraValue.value = updateId.value
    const row = DEVICE_SERVER_LIST.find((el) => el.value === updateId.value)
    videoValue.value = DEVICE_CAMERA_LIST[updateId.value][0].value
    oldDeviceValue.value = updateId.value
  } else if (updateType.value === 'camera') {
    videoValue.value = updateId.value
    oldDeviceCameraValue.value = updateId.value
  }
  updateTipModal.value = false
}
function handleCloseUpdate () {
  if (updateType.value === 'device') {
    choseValue.value = oldDeviceValue.value
  } else if (updateType.value === 'camera') {
    videoValue.value = oldDeviceCameraValue.value
  }
  updateTipModal.value = false
}
function handleDeviceCameraChange (selectId) {
  if (waylineForm.value.id) {
    updateType.value = 'camera'
    updateTipModal.value = true
    updateId.value = selectId
  }
}

const openModal = (
  row?: lineSaveForm & { dept_ids?: string; dept_names?: string },
) => {
  addModal.value = true
  // 重置表单基础字段
  waylineForm.value = {
    name: '',
    drone_model_key: '',
    payload_model_keys: [],
    template_types: [],
    wayline_property: '',
    user_names: '',
    user_id_list: [],
    dept_ids: '',
    dept_names: '',
    inspection_area_id: null,
  }
  // 重置部门选择相关状态
  selectedDeptKeys.value = []
  selectedDeptNames.value = []
  showDeptPanel.value = false

  if (waylineAttribute.value && waylineAttribute.value[0]?.dictValue) {
    waylineForm.value.wayline_property = waylineAttribute.value[0].dictValue
  }
  if (waylineComType.value && waylineComType.value[0]?.dictValue) {
    waylineForm.value.template_types = [waylineComType.value[0].dictValue]
  }
  choseValue.value = DRONE_TYPE.M30
  videoValue.value = DEVICE_CAMERA_LIST[choseValue.value][0].value

  // 编辑时回填数据
  if (row && row.drone_type) {
    waylineForm.value = { ...row }
    waylineForm.value.template_types = [row.template_types[0] + '']
    waylineForm.value.wayline_property = row.wayline_property
      ? row.wayline_property + ''
      : waylineAttribute.value[0]?.dictValue
    if (row.device_sn) {
      assAirport.value = row.device_sn
    }
    choseValue.value = Number(row.drone_type)
    videoValue.value = Number(row.payload_types)
    oldDeviceValue.value = choseValue.value
    oldDeviceCameraValue.value = videoValue.value

    // 编辑时部门数据回显
    if (row.dept_ids) {
      waylineForm.value.dept_ids = row.dept_ids
      // 将字符串 ID 转为数字数组（与树节点 key 类型匹配）
      const ids = row.dept_ids
        .split(',')
        .filter(Boolean)
        .map((id) => Number(id))
      const names: string[] = []
      const collectNames = (nodes: any[]) => {
        nodes.forEach((node) => {
          // 直接比较数字
          if (ids.includes(node.key)) {
            names.push(node.title)
          }
          if (node.children) collectNames(node.children)
        })
      }
      collectNames(deptTreeData.value)
      selectedDeptKeys.value = ids // 现在是数字数组
      selectedDeptNames.value = names
      waylineForm.value.dept_names = names.join('、')
    }

    if (row.inspection_area_id) {
      waylineForm.value.inspection_area_id = row.inspection_area_id
    }
  }
}

async function routeType () {
  const res = await getDictList('route_type')
  if (res && res.code === 0) {
    waylineComType.value = res.data || []
    waylineForm.value.template_types = [res.data[0].dictValue]
  }
}

function handleChangeType (item) {
  waylineForm.value.template_types = [item.dictValue]
  if (item.dictValue === '3') {
    const lists = DEVICE_SERVER_LIST.filter(
      (el) => el.value !== DRONE_TYPE.M30,
    )
    choseValue.value = lists[0].value
    videoValue.value = DEVICE_CAMERA_LIST[choseValue.value][0].value
  }
}
function handleSave () {
  if (!waylineForm.value.name) {
    errorForm.value.nameNone = true
    return
  }
  errorForm.value.nameNone = false
  errorForm.value.nameOr = false
  emits('save', {
    form: waylineForm.value,
    assAirport: assAirport.value,
    choseValue: choseValue.value,
    videoValue: videoValue.value,
    errorForm: errorForm.value,
  })
  console.log('waylineForm.value', waylineForm.value)
}

const handleCancle = () => {
  waylineForm.value = {
    name: '',
    drone_model_key: '',
    payload_model_keys: [],
    template_types: [],
    wayline_property: '',
    user_names: '',
    user_id_list: [],
    dept_ids: '',
    dept_names: '',
    inspection_area_id: null,
  }
  errorForm.value = {
    nameNone: false,
    nameOr: false,
  }
  // 重置部门选择相关状态
  selectedDeptKeys.value = []
  selectedDeptNames.value = []
  showDeptPanel.value = false

  choseValue.value = DRONE_TYPE.M30
  videoValue.value = DEVICE_CAMERA_LIST[choseValue.value][0].value

  addModal.value = false
}

const showDeptPanel = ref(false)
const deptTreeData = ref<any[]>([])
const selectedDeptKeys = ref<string[]>([])
const selectedDeptNames = ref<string[]>([])
const expandedDeptKeys = ref<string[]>([])

const fetchDeptTree = async () => {
  try {
    const res = await getDeptList()
    if (res.code === 200 && res.data) {
      deptTreeData.value = buildTreeData(res.data)
      if (deptTreeData.value.length) {
        expandedDeptKeys.value = deptTreeData.value.map((node) => node.key)
      }
    }
  } catch (error) {
    console.error('获取部门列表失败', error)
  }
}

const buildTreeData = (nodes: any[], isRoot = true): any[] => {
  if (!nodes || !nodes.length) return []
  return nodes.map((node) => ({
    title: node.label,
    key: node.id,
    disableCheckbox: isRoot,
    children: node.children ? buildTreeData(node.children, false) : [],
  }))
}

const onDeptCheck = (checkedKeys: any) => {
  const keys = Array.isArray(checkedKeys)
    ? checkedKeys
    : checkedKeys.checked || []
  selectedDeptKeys.value = keys

  const names: string[] = []
  const collectNames = (nodes: any[]) => {
    nodes.forEach((node) => {
      if (keys.includes(node.key)) {
        names.push(node.title)
      }
      if (node.children) collectNames(node.children)
    })
  }
  collectNames(deptTreeData.value)
  selectedDeptNames.value = names

  // 更新表单字段
  waylineForm.value.dept_ids = keys.join(',')
  waylineForm.value.dept_names = names.join('、')
}

// 巡检区域
const flightData = ref([])

const convertToTreeData = (items: any[]): any[] => {
  return items.map(item => ({
    key: item.id,
    title: item.name,
    value: item.id,
    children: item.hasChildren && item.children ? convertToTreeData(item.children) : undefined,
    isLeaf: !item.hasChildren
  }))
}

const flightAreaTreeData = computed(() => convertToTreeData(flightData.value))

const fetchFlightAreaData = async () => {
  const res = await getCheckInspectionAreasList()
  flightData.value = res.data
}

onMounted(() => {
  waylineAttList()
  // getDockSN()
  routeType()
  fetchDeptTree()
  fetchFlightAreaData()
})

defineExpose({
  openModal,
  handleCancle,
  dockSnList: dockSnList.value,
})
</script>
<style scoped lang="scss">
/* ========== 自定义样式（暗色适配） ========== */
.form-tips {
  color: #ff6b6b;
  font-size: 12px;
}

.wayline-type-btn{
  background: rgba(0, 0, 0, 0.6);
  color:#fff;
  border-color: rgba(0, 0, 0, 0.6);
  &:hover,&:focus,&:active,&:visited {
    background: rgba(#69c0ff, 0.3);
    border-color: rgba(#69c0ff, 0.3);
  }
  &.ant-btn-true {
  color: #69c0ff;
  border-color: #69c0ff;
}
}

.addModal {
  margin-bottom: 20px;
  font-size: 15px;
  color: #e8e8e8;
}

.sel {
  margin-top: 5px;
  width: 100%;
}

.chose {
  width: 195px;
}

.user-top {
  position: relative;
  text-align: center;

  .user-text {
    font-size: 16px;
    font-weight: bold;
    color: #e8e8e8;
  }

  .user-close {
    position: absolute;
    right: 5px;
    top: 3px;
    color: #b0b0b0;
    cursor: pointer;

    &:hover {
      color: #ffffff;
    }
  }
}

.dept-selector {
  display: flex;
  align-items: center;
  position: relative;
}

.dept-panel {
  position: fixed;
  top: 55%;
  left: calc(50% + 225px + 4px);
  transform: translateY(-50%);
  width: 320px;
  background: #1f1f1f;
  color: #e0e0e0;
  padding: 8px 12px;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.6);
  z-index: 2000;
  border-radius: 4px;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;

  .dept-panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    font-weight: bold;
    color: #e0e0e0;

    .close-icon {
      color: #b0b0b0;
      cursor: pointer;
      transition: color 0.2s;

      &:hover {
        color: #ffffff;
      }
    }
  }

  .dept-tree-container {
    max-height: 300px;
    overflow-y: auto;
  }
}
</style>

<style lang="scss">
/* ========== Ant Design 组件暗色覆盖（限定作用于当前组件） ========== */
/* 限定 Modal 容器 */
.dark-modal-wrapper {
  .ant-modal-content {
    background: #1f1f1f;
    color: #e8e8e8;
    border: 1px solid #333;
  }

  .ant-modal-header {
    background: #1f1f1f;
    border-bottom: 1px solid #333;
    color: #e8e8e8;

    .ant-modal-title {
      color: #e8e8e8;
    }
  }

  .ant-modal-close-x {
    color: #b0b0b0;

    &:hover {
      color: #ffffff;
    }
  }

  .ant-modal-body {
    background: #1f1f1f;
    color: #e8e8e8;
  }

  .ant-modal-footer {
    border-top: 1px solid #333;
    background: #1f1f1f;

    .ant-btn {
      background: #2d2d2d;
      border-color: #444;
      color: #e8e8e8;

      &:hover {
        background: #3d3d3d;
        border-color: #666;
      }

      &.ant-btn-primary {
        background: #1890ff;
        border-color: #1890ff;
        color: #fff;

        &:hover {
          background: #40a9ff;
          border-color: #40a9ff;
        }
      }

      &.ant-btn-danger {
        background: #ff4d4f;
        border-color: #ff4d4f;
        color: #fff;

        &:hover {
          background: #ff7875;
          border-color: #ff7875;
        }
      }
    }
  }

  /* 输入框 */
  .ant-input {
    background: #2d2d2d;
    border-color: #444;
    color: #e8e8e8;

    &::placeholder {
      color: #888;
    }

    &:hover,
    &:focus {
      border-color: #69c0ff;
      box-shadow: 0 0 0 2px rgba(105, 192, 255, 0.2);
    }

    &:read-only {
      background: #1f1f1f;
      cursor: default;
    }
  }

  /* 选择器（下拉框样式在外部限定） */
  .ant-select-selector {
    background: #2d2d2d !important;
    border-color: #444 !important;
    color: #e8e8e8 !important;

    .ant-select-selection-placeholder {
      color: #888 !important;
    }

    .ant-select-arrow {
      color: #b0b0b0;
    }
  }

  /* 树组件 */
  .ant-tree {
    background: transparent;
    color: #e8e8e8;

    .ant-tree-node-content-wrapper {
      color: #e8e8e8;

      &:hover {
        background: rgba(255, 255, 255, 0.05);
      }
    }

    .ant-tree-checkbox-inner {
      background-color: #2d2d2d;
      border-color: #555;
    }

    .ant-tree-checkbox-checked .ant-tree-checkbox-inner {
      background-color: #1890ff;
      border-color: #1890ff;
    }

    .ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner {
      background-color: #1890ff;
      border-color: #1890ff;
    }

    .ant-tree-switcher {
      color: #b0b0b0;
    }

    .ant-tree-treenode-selected {
      .ant-tree-node-content-wrapper {
        background: rgba(24, 144, 255, 0.2);
      }
    }
  }

  /* 复选框组（人员面板中的 checkbox） */
  .ant-checkbox-wrapper {
    color: #e8e8e8;

    .ant-checkbox-inner {
      background-color: #2d2d2d;
      border-color: #555;
    }

    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #1890ff;
      border-color: #1890ff;
    }

    .ant-checkbox-indeterminate .ant-checkbox-inner {
      background-color: #1890ff;
      border-color: #1890ff;
    }
  }

  /* 按钮（一般样式） */
  .ant-btn {
    background: #2d2d2d;
    border-color: #444;
    color: #e8e8e8;

    &:hover {
      background: #3d3d3d;
      border-color: #666;
    }

    &.ant-btn-primary {
      background: #1890ff;
      border-color: #1890ff;
      color: #fff;

      &:hover {
        background: #40a9ff;
        border-color: #40a9ff;
      }
    }

    &.ant-btn-danger {
      background: #ff4d4f;
      border-color: #ff4d4f;
      color: #fff;

      &:hover {
        background: #ff7875;
        border-color: #ff7875;
      }
    }

    &.ant-btn-text {
      background: transparent;
      border-color: transparent;
      color: #69c0ff;

      &:hover {
        background: rgba(105, 192, 255, 0.1);
      }
    }
  }
}

/* 限定下拉框（Select dropdown） */
.dark-select-dropdown {
  background: #1f1f1f;
  border: 1px solid #333;

  .ant-select-item {
    color: #e8e8e8;
    background: transparent;

    &:hover {
      background: rgba(255, 255, 255, 0.05);
    }

    &.ant-select-item-option-selected {
      background: rgba(24, 144, 255, 0.2);
    }
  }

  .ant-select-item-option-disabled {
    color: #888;
    cursor: not-allowed;
  }
}

/* （可选）如果不想修改模板加类名，可全局覆盖，取消注释以下代码并注释上方的限定选择器 */
/*
.ant-modal-content,
.ant-modal-header,
.ant-modal-body,
.ant-modal-footer {
  background: #1f1f1f !important;
  color: #e8e8e8 !important;
}
.ant-input,
.ant-select-selector {
  background: #2d2d2d !important;
  border-color: #444 !important;
  color: #e8e8e8 !important;
}
.ant-tree,
.ant-checkbox-wrapper {
  color: #e8e8e8;
}
.ant-tree-checkbox-inner,
.ant-checkbox-inner {
  background-color: #2d2d2d !important;
  border-color: #555 !important;
}
.ant-select-dropdown {
  background: #1f1f1f;
}
*/
</style>
